
import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';
import * as ui from '../../ui';
import { types } from '../../api_types';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faLock,
  faUnlock,
  faQuestionCircle,
  faCogs,
} from '@fortawesome/free-solid-svg-icons';
import { getBlogUrl } from '../../urlHelper';
library.add(faLock);
library.add(faUnlock);
library.add(faQuestionCircle);
library.add(faCogs);

import omegaup_problemMarkdown from './ProblemMarkdown.vue';

@Component({
  components: {
    'omegaup-markdown': omegaup_problemMarkdown,
    FontAwesomeIcon,
  },
})
class ProblemSolution extends Vue {
  @Prop() status!: string;
  @Prop({ default: null }) solution!: types.ProblemStatement | null;
  @Prop() allowedSolutionsToSee!: number;
  @Prop({ default: true }) isDisabled!: boolean;

  T = T;
  ui = ui;

  get SolutionViewFeatureGuideURL(): string {
    return getBlogUrl('SolutionViewFeatureGuideURL');
  }
  get showSolution(): boolean {
    return this.status === 'unlocked' && this.solution !== null;
  }

  get statusMessage(): string {
    switch (this.status) {
      case 'unlocked':
        return T.solutionConfirm;
      case 'locked':
        return T.solutionLocked;
      case 'not_found':
        return T.solutionNotFound;
      case 'not_logged_in':
        return T.solutionNotLoggedIn;
      default:
        return '';
    }
  }
  get showViewsLeft(): boolean {
    return (
      this.allowedSolutionsToSee !== null && this.status !== 'not_logged_in'
    );
  }
}

export default ProblemSolution;
